import {
  Users,
  FileText,
  FolderKanban,
  FileCheck,
  CheckSquare,
  CheckSquare2,
  ScrollText,
  User,
  UserCircle,
  ListTodo,
  Target,
  LucideIcon,
} from 'lucide-react';
import { CommandItem } from '@/components/ui/command';
import { Badge } from '@/components/ui/badge';
import { SearchResult, SearchEntityType } from '@/hooks/useUniversalSearch';

const ENTITY_ICONS: Record<SearchEntityType, LucideIcon> = {
  client: Users,
  meeting: FileText,
  project: FolderKanban,
  contract: FileCheck,
  obligation: CheckSquare,
  script: ScrollText,
  team_member: User,
  client_team: UserCircle,
  task: ListTodo,
  synced_task: CheckSquare2,
  goal: Target,
};

const ENTITY_LABELS: Record<SearchEntityType, string> = {
  client: 'Client',
  meeting: 'Meeting',
  project: 'Project',
  contract: 'Contract',
  obligation: 'Obligation',
  script: 'Script',
  team_member: 'Team',
  client_team: 'Contact',
  task: 'Task',
  synced_task: 'ClickUp Task',
  goal: 'Goal',
};

interface SearchResultItemProps {
  result: SearchResult;
  onSelect: () => void;
}

export function SearchResultItem({ result, onSelect }: SearchResultItemProps) {
  const Icon = ENTITY_ICONS[result.entity_type] || FileText;

  return (
    <CommandItem
      onSelect={onSelect}
      className="flex items-center gap-3 py-3 px-2 cursor-pointer"
      value={`${result.entity_type}-${result.id}-${result.title}`}
    >
      <div className="flex h-8 w-8 items-center justify-center rounded-md bg-muted shrink-0">
        <Icon className="h-4 w-4 text-muted-foreground" />
      </div>
      <div className="flex-1 min-w-0 overflow-hidden">
        <div className="flex items-center gap-2">
          <span className="font-medium truncate">{result.title}</span>
          <Badge variant="outline" className="text-xs shrink-0">
            {ENTITY_LABELS[result.entity_type]}
          </Badge>
        </div>
        {result.subtitle && (
          <p className="text-sm text-muted-foreground truncate">
            {result.subtitle}
          </p>
        )}
        {result.client_name && result.entity_type !== 'client' && (
          <p className="text-xs text-muted-foreground/70 truncate">
            {result.client_name}
          </p>
        )}
      </div>
    </CommandItem>
  );
}
